import { render, staticRenderFns } from "./ShowsAdm.vue?vue&type=template&id=7750edca&scoped=true&"
import script from "./ShowsAdm.vue?vue&type=script&lang=js&"
export * from "./ShowsAdm.vue?vue&type=script&lang=js&"
import style0 from "./ShowsAdm.vue?vue&type=style&index=0&id=7750edca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7750edca",
  null
  
)

export default component.exports